// extracted by mini-css-extract-plugin
export var typingIndicator = "_n6-0";